import React from 'react'
import './Proyectos.css'
function Card({imagen,nombre, link, link2 }) {
  return (
    <div>
        <div className='contenedor-card'>
            <img className='img-card' src={imagen}/>
            <h2>{nombre}</h2>
            <button className='boton-card'> <a href={link}>Comprar Curso</a></button>
            <button className='boton-card'> <a href={link2}>Ver Contenido del curso</a></button>

        </div>
    </div>
  )
}

export default Card